import React, { useEffect, useState, useRef, useContext } from "react";
import { createChart } from 'lightweight-charts';
import { AuthContext } from "../../AuthContext";
import PageServices from "../../services/PageServices";

const StraddleChart = () => {
  const [data, setData] = useState([]);

  const [straddleData, setStraddleData] = useState([]);
  const [showVWAP, setShowVWAP] = useState(false);
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);
  const seriesRef = useRef(null);
  const priceSeriesRef = useRef(null); // LastTradePrice line
  const vwapSeriesRef = useRef(null); // VWAP line
  const [rangeStart, setRangeStart] = useState(null);
  const [rangeEnd, setRangeEnd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [processedData, setProcessedData] = useState([]);
  const [selectedStrikePrice, setSelectedStrikePrice] = useState(null);
  const [greekChainData, setGreekChainData] = useState([]);
  const [intraDay, setIntraDay] = useState('')
  const [chartData, setChartData] = useState([]);
  const [highestCEOIChange, setHighestCEOIChange] = useState(0);
  const [secondHighestCEOIChange, setSecondHighestCEOIChange] = useState(0);
  const [thirdHighestCEOIChange, setThirdHighestCEOIChange] = useState(0);

  const [highestCEOI, setHighestCEOI] = useState(0);
  const [secondHighestCEOI, setSecondHighestCEOI] = useState(0);
  const [thirdHighestCEOI, setThirdHighestCEOI] = useState(0);

  const [highestCEVolume, setHighestCEVolume] = useState(0);
  const [secondHighestCEVolume, setSecondHighestCEVolume] = useState(0);
  const [thirdHighestCEVolume, setThirdHighestCEVolume] = useState(0);
  const [highestPEOIChange, setHighestPEOIChange] = useState(0);
  const [secondHighestPEOIChange, setSecondHighestPEOIChange] = useState(0);
  const [thirdHighestPEOIChange, setThirdHighestPEOIChange] = useState(0);
  const [highestPEOI, setHighestPEOI] = useState(0);
  const [secondHighestPEOI, setSecondHighestPEOI] = useState(0);
  const [thirdHighestPEOI, setThirdHighestPEOI] = useState(0);
  const [highestPEVolume, setHighestPEVolume] = useState(0);
  const [secondHighestPEVolume, setSecondHighestPEVolume] = useState(0);
  const [thirdHighestPEVolume, setThirdHighestPEVolume] = useState(0);

  const [resistanceLevel, setResistanceLevel] = useState(null);
  const [supportLevel, setSupportLevel] = useState(null);
  const [futurePrice, setFutrePrice] = useState(0);
  const [previousHistory, setPreviousHistory] = useState([]);
  const [support, setSupport] = useState(0);
  const [resistance, setResistance] = useState(0);
  const [support2, setSupport2] = useState(0);
  const [resistance2, setResistance2] = useState(0);

  const [futureSupport, setFutureSupport] = useState(0);
  const [futureResistance, setFutureResistance] = useState(0);
  const [futureSupport2, setFutureSupport2] = useState(0);
  const [futureResistance2, setFutureResistance2] = useState(0);
  const [date, setDate] = useState(0);
  const [weeklyUpper, setWeeklyUpper] = useState(0);
  const [weeklyDown, setWeeklyDown] = useState(0);
  const [day, setDay] = useState(null);
  const [firstOptionChain, setFirstOptionChain] = useState([]);
  const [open, setOpen] = useState(false);


  const [oldData, setOldData] = useState([]);
  const [spotPrice, setSpotPrice] = useState(0);



  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {

      // count ema 
      function calculateEMA(values, period = 3) {
        let ema = values[2]?.Low; // Start with the first value as the initial EMA
        const smoothingFactor = 2 / (period + 1); // Smoothing factor (multiplier)

        for (let i = 1; i >= 0; i--) {
          ema = (smoothingFactor * values[i].Low) + ((1 - smoothingFactor) * ema);
        }

        return ema;
      }
      let response

      if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER" || localStorage.getItem('stock') === 'CRUDEOIL' || localStorage.getItem("stock") === "COPPER" || localStorage.getItem("stock") === "NATURALGAS") {

        response = await PageServices.getComodityOptionChain({
          symbolToken: localStorage.getItem("stock"),
        });
        console.log(">>>>>>>>>res1", response);
      } else {

        response = await PageServices.getOptionChain({
          symbolToken: localStorage.getItem("stock"),
        });
        response.formattedData.sort((x, y) => parseFloat(x.strikePrice) - parseFloat(y.strikePrice));
        // console.log(">>>>>>>>>res123",res123);
      }


      PageServices.getDataForSuportandRessitans(localStorage.getItem("stock")).then((response) => {
        setFirstOptionChain(response);
        //  console.log(response);
      }).catch((error) => {
        console.error('Error fetching data for support and ressitance:', error);
      });

      // Ensure response.sub and response.future exist before accessing them
      setSpotPrice(response?.spotPrice?.LastTradePrice ?? 0);
      setFutrePrice(response?.futurePrice?.LastTradePrice ?? 0);
      // onTradingChange(response?.historical);
      setPreviousHistory(response?.historical);
      const currentDate = new Date();

      // Extract the components from the date
      const month = currentDate.toLocaleString('default', { month: 'short' });  // Short month name (e.g., "Dec")
      const day = String(currentDate.getDate()).padStart(2, '0');  // Day with leading zero if necessary
      const year = currentDate.getFullYear();  // Full year (e.g., 2024)
      const hours = String(currentDate.getHours()).padStart(2, '0');  // Hours with leading zero
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');  // Minutes with leading zero
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');  // Seconds with leading zero

      // Combine them into the desired format
      const formattedDate = `${month} ${day} ${hours}:${minutes}:${seconds}`;

      setDate(formattedDate);

      const emaLow = calculateEMA(response?.historicalResponseEx?.Result)


      // console.log("emaLow",emaLow    ,response?.historicalResponseEx?.Result[0].Close )
      if (response?.historicalResponseEx?.Result[0].Close > emaLow) {

        console.log(emaLow, "Bullish: Close is greater than EMA", response?.historicalResponseEx?.Result[0]?.close);
      } else {
        console.log("Bearish: Close is less than EMA");
      }
      console.log(">>REs>>>", response)
      console.log("response?.formattedData", response.formattedData)
      if (Array.isArray(response?.formattedData)) {
        let middleValues = response?.formattedData
        let midleIndex;
        response.formattedData.some((item, index) => {
          if (item?.strikePrice >= response?.spotPrice?.LastTradePrice) {
            midleIndex = index;
            return true;  // This will stop the iteration
          }
          return false;
        });

        // response.formattedData.forEach((item, index) => {
        //   if (item.strikePrice >= response.spotPrice?.LastTradePrice) {
        //     midleIndex = index;
        //     return;  // This will stop the iteration
        //   }
        // });

        let upperIndex;
        let lowerIndex;

        if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER" || localStorage.getItem('stock') === 'CRUDEOIL' || localStorage.getItem("stock") === "COPPER" || localStorage.getItem("stock") === "NATURALGAS") {

          upperIndex = Math.max(midleIndex - 40, 0);  // Prevent negative indices
          lowerIndex = Math.min(midleIndex + 40, middleValues.length);
        } else {
          upperIndex = Math.max(midleIndex - 20, 0);  // Prevent negative indices
          lowerIndex = Math.min(midleIndex + 20, middleValues.length);
        }
        const finalData = middleValues.slice(upperIndex, lowerIndex)
        console.log("finalData1", finalData)

        if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER") {

          let step;
          let currentValue
          // localStorage.getItem("stock") === "GOLD" ? currentValue = 85000 : currentValue = 80000 
          localStorage.getItem("stock") === "GOLD" ? step = 500 : step = 1000
          // Convert strike prices to numbers and sort
          const strikePrices = finalData.map(item => parseInt(item.strikePrice)).sort((a, b) => a - b);

          // Find the first strike price that ends with '000'
          currentValue = strikePrices.find(price => price % 1000 === 0);
          console.log("finalData2", finalData)
          console.log("Final Data Before Filtering:", finalData.map(item => item.strikePrice));
          console.log("Current Value Before Filtering:", currentValue);
          console.log("Dynamic Current Value (Lowest Strike):", currentValue);

          const filteredArray = finalData.filter(value => {
            if (value.strikePrice == currentValue) {
              currentValue += step; // increment the current value
              return true;
            }
            return false;
          });
          console.log("filteredArray", filteredArray)
          setData(filteredArray);
          console.log(">>data1", data)
        } else {
          if (localStorage.getItem('reverseTable') === "true") {
            finalData.reverse();
          }
          setData(finalData);
          if (finalData.length > 0) {
            setRangeStart(finalData[0].strikePrice);
            setRangeEnd(finalData[finalData.length - 1].strikePrice);
          }
          console.log(">>data2", data)
        }



        // Find the highest and second-highest values for each column
        const ceOpenInterestChanges = [
          ...new Set(
            finalData.map(
              (item) => item.CE?.OpenInterestChange ?? 0
            )
          ),
        ].sort((a, b) => b - a);

        const ceOpenInterests = [
          ...new Set(
            finalData.map((item) => item.CE?.OpenInterest ?? 0)
          ),
        ].sort((a, b) => b - a);
        const ceTotalQtyTraded = [
          ...new Set(
            finalData.map((item) => item.CE?.TotalQtyTraded ?? 0)
          ),
        ].sort((a, b) => b - a);
        const peOpenInterestChanges = [
          ...new Set(
            finalData.map(
              (item) => item.PE?.OpenInterestChange ?? 0
            )
          ),
        ].sort((a, b) => b - a);
        const peOpenInterests = [
          ...new Set(
            finalData.map((item) => item.PE?.OpenInterest ?? 0)
          ),
        ].sort((a, b) => b - a);
        const peTotalQtyTraded = [
          ...new Set(
            finalData.map((item) => item.PE?.TotalQtyTraded ?? 0)
          ),
        ].sort((a, b) => b - a);

        const setValues = (values, setHighest, setSecond, setThird) => {
          setHighest(values[0] || 0);
          setSecond(values[1] || 0);
          setThird(values[2] || 0);
        };

        setValues(
          ceOpenInterestChanges,
          setHighestCEOIChange,
          setSecondHighestCEOIChange,
          setThirdHighestCEOIChange
        );
        setValues(
          ceOpenInterests,
          setHighestCEOI,
          setSecondHighestCEOI,
          setThirdHighestCEOI
        );
        setValues(
          ceTotalQtyTraded,
          setHighestCEVolume,
          setSecondHighestCEVolume,
          setThirdHighestCEVolume
        );
        setValues(
          peOpenInterestChanges,
          setHighestPEOIChange,
          setSecondHighestPEOIChange,
          setThirdHighestPEOIChange
        );
        setValues(
          peOpenInterests,
          setHighestPEOI,
          setSecondHighestPEOI,
          setThirdHighestPEOI
        );
        setValues(
          peTotalQtyTraded,
          setHighestPEVolume,
          setSecondHighestPEVolume,
          setThirdHighestPEVolume
        );

        const maxCEOI = Math.max(
          ...response.formattedData.map((item) => item.CE?.OpenInterest || 0)
        );
        const maxPEOI = Math.max(
          ...response.formattedData.map((item) => item.PE?.OpenInterest || 0)
        );
        const resistance = response.formattedData.find(
          (item) => item.CE?.OpenInterest === maxCEOI
        )?.strikePrice;
        const support = response.formattedData.find(
          (item) => item.PE?.OpenInterest === maxPEOI
        )?.strikePrice;
        setResistanceLevel(resistance);
        setSupportLevel(support);
      } else {
        // If formattedData is not an array, set loading to false
        setLoading(false);
        // console.error("Invalid formattedData:", response.formattedData);
      }

      setLoading(false);
    } catch (error) {
      // console.log(error);
      setLoading(false);
    }
  };


  // Transform API flat data → chart points
  const transformStraddleData = (rawData, useVWAP = false) => {
    console.log("Raw data received in transformStraddleData:", rawData);

    const groupedByMinute = {};

    rawData.forEach((item) => {
      const time = item?.lastTradeTime;
      if (!time || typeof time !== "string") return;

      const [hh, mm] = time.split(":");
      const minuteKey = `${hh}:${mm}`;

      if (!groupedByMinute[minuteKey]) {
        groupedByMinute[minuteKey] = item;
      } else {
        if (item.lastTradePrice > groupedByMinute[minuteKey].lastTradePrice) {
          groupedByMinute[minuteKey] = item;
        }
      }
    });

    console.log("Grouped by minute (max price each):", groupedByMinute);

    // Step 2: Convert to chart format
    return Object.entries(groupedByMinute)
      .map(([minute, item]) => {
        const [hours, minutes] = minute.split(":").map(Number);

        // Get today's date
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); // 0-based
        const day = today.getDate();

        const istDate = new Date(year, month, day, hours, minutes, 0);
        const utcMillis = istDate.getTime() - 5.5 * 60 * 60 * 1000;

        return {
          time: Math.floor(utcMillis / 1000),
          value: useVWAP ? item.averageTradedPrice || 0 : item.lastTradePrice || 0
        };
      })
      .sort((a, b) => a.time - b.time);
  };



  // const renderChart = (rawData, useVWAP) => {
  //   if (!rawData || rawData.length === 0) {
  //     console.warn("No chart data to render");
  //     return;
  //   }



  //   if (!chartRef.current) {
  //     chartRef.current = createChart(chartContainerRef.current, {
  //       width: chartContainerRef.current.clientWidth,
  //       height: 500,
  //       layout: { background: { color: "#fff" }, textColor: "#000" },
  //       grid: { vertLines: { color: "#eee" }, horzLines: { color: "#eee" } },
  //       timeScale: { timeVisible: true, secondsVisible: true },
  //     });
  //   }

  //   if (seriesRef.current) {
  //     chartRef.current.removeSeries(seriesRef.current);
  //   }

  //   seriesRef.current = chartRef.current.addLineSeries({
  //     color: useVWAP ? "#ff0000" : "#000",
  //     lineWidth: 2,
  //   });

  //   const formattedData = transformStraddleData(rawData, useVWAP);
  //   console.log("Formatted chart data:", formattedData); // debug

  //   seriesRef.current.setData(formattedData);
  // };

  const renderChart = (rawData, showVWAP) => {
    if (!rawData || rawData.length === 0) {
      console.warn("No chart data to render");
      return;
    }

    if (!chartRef.current) {
      chartRef.current = createChart(chartContainerRef.current, {
        width: chartContainerRef.current.clientWidth,
        height: 500,
        layout: { background: { color: "#fff" }, textColor: "#000" },
        grid: { vertLines: { color: "#eee" }, horzLines: { color: "#eee" } },
        timeScale: { timeVisible: true, secondsVisible: true },
      });
    }

    // ---- LastTradePrice line (always visible) ----
    if (!priceSeriesRef.current) {
      priceSeriesRef.current = chartRef.current.addLineSeries({
        color: "#000", // Black line
        lineWidth: 2,
      });
      const priceData = transformStraddleData(rawData, false); // lastTradePrice
      priceSeriesRef.current.setData(priceData);
    }

    // ---- VWAP line (toggle) ----
    if (showVWAP) {
      if (!vwapSeriesRef.current) {
        vwapSeriesRef.current = chartRef.current.addLineSeries({
          color: "#ff0000", // Red VWAP line
          lineWidth: 2,
        });
      }
      const vwapData = transformStraddleData(rawData, true); // VWAP
      vwapSeriesRef.current.setData(vwapData);
    } else {
      if (vwapSeriesRef.current) {
        chartRef.current.removeSeries(vwapSeriesRef.current);
        vwapSeriesRef.current = null;
      }
    }
  };
  const toggleVWAP = () => {
    setShowVWAP(prev => {
      const newValue = !prev;
      renderChart(straddleData, newValue);
      return newValue;
    });
  };

  useEffect(() => {
    const fetchStraddleData = async () => {
      try {
        const symbolToken = localStorage.getItem("stock");
        const minStrike = 24100;
        const maxStrike = 25100;

        if (!symbolToken) {
          console.warn("No symbol token found in localStorage");
          return;
        }

        const res = await PageServices.getStraddleChart(
          symbolToken,
          minStrike,
          maxStrike
        );
        console.log(">>>>>res", res)
        if (res?.success) {
          setStraddleData(res.data);
          renderChart(res.data, false); // Default chart
        } else {
          console.error("API returned error:", res?.data?.message);
        }
      } catch (error) {
        console.error("Error fetching straddle chart:", error);
      }
    };

    fetchStraddleData();
  }, []);
  useEffect(() => {
    if (data.length > 0) {
      // Sare strikePrices ko number me convert karke sort karo
      const strikePrices = data.map(item => Number(item.strikePrice)).sort((a, b) => a - b);

      // Range set karo
      setRangeStart(strikePrices[0]); // Lowest
      setRangeEnd(strikePrices[strikePrices.length - 1]); // Highest
    }
  }, [data]);

  console.log("??>>>>>data", data)
  return (
    <div>
      <h2 style={{ textAlign: "center" }}>Straddle Chart</h2>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
        <select value={rangeStart} onChange={e => setRangeStart(Number(e.target.value))}>
          {data.map((item, idx) => (
            <option key={idx} value={item.strikePrice}>
              {item.strikePrice}
            </option>
          ))}
        </select>

        <select value={rangeEnd} onChange={e => setRangeEnd(Number(e.target.value))}>
          {data.map((item, idx) => (
            <option key={idx} value={item.strikePrice}>
              {item.strikePrice}
            </option>
          ))}
        </select>
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
        <button onClick={toggleVWAP}>
          {showVWAP ? "Hide VWAP Line" : "Show VWAP Line"}
        </button>
      </div>

      <div ref={chartContainerRef} style={{ width: "100%", height: "500px" }} />
    </div>
  );
};


export default StraddleChart;
